<template>
  <div v-if="showComponent" class="mb-3">
    <template v-if="googleMapsApiKey !== null">
      <LmGooglePlacesAutocomplete
        :label="label"
        @placeChanged="placeChanged"
        @inputLmGooglePlacesAutocomplete="inputLmGooglePlacesAutocomplete"
        :value="value.formattedAddress"
      />

      <l-map
        :style="{ height: height }"
        style="width: 100%"
        class="shadow-sm"
        :zoom="Number(zoom)"
        :center="initPosition"
        :options="options"
      >
        <l-tile-layer :url="tile" />
        <l-marker v-if="markerLatLng.length" :lat-lng="markerLatLng"></l-marker>
      </l-map>
    </template>
    <template v-else>
      <b-card bg-variant="light" class="text-center border">
        <template #header>
          <i class="mdi mdi-alert-outline"></i>
          Clave de producto no encontrada
        </template>
        <b-card-text>No pudimos localizar una clave de producto válida para utilizar los mapas. Por favor pongase en contacto con su proveedor de servicios.</b-card-text>
      </b-card>
    </template>
  </div>
</template>

<script>
import LmGooglePlacesAutocomplete from '@/components/LmGooglePlacesAutocomplete.vue'
import { mapGetters } from 'vuex'
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'

// Utils
import LmCommonProps from '@/mixins/LmCommonProps'

export default {
  mixins: [LmCommonProps],
  components: {
    LmGooglePlacesAutocomplete,
    'l-map': LMap,
    'l-tile-layer': LTileLayer,
    'l-marker': LMarker
  },
  props: {
    initialPosition: {
      type: Object
    },
    label: {
      type: String,
      default: 'Dirección'
    },
    value: {
      type: Object,
      default: () => ({
        formattedAddress: '',
        latLong: []
      })
    },
    zoom: {
      type: [Number, String],
      default: 16
    },
    height: {
      type: String,
      default: '400px'
    },
    isVisible: {
      type: Boolean,
      default: true
    },
    options: {
      type: Object,
      default: () => ({ scrollWheelZoom: false })
    },
    tile: {
      type: String,
      default: 'https://{s}.tile.osm.org/{z}/{x}/{y}.png'
    }
  },
  computed: {
    ...mapGetters('settings', ['googleMapsApiKey']),
    markerLatLng: {
      get () {
        return this.value.latLong || []
      },
      set (val) {
        this.value.latLong = val
      }
    },
    initPosition () {
      if (this.markerLatLng.length) {
        return this.markerLatLng
      }
      return this.initialPosition.latLong
    }
  },
  methods: {
    placeChanged (place) {
      const latLong = [
        place.geometry.location.lat(),
        place.geometry.location.lng()
      ]
      const data = {
        latLong: latLong,
        formattedAddress: place.formatted_address
      }
      this.$emit('input', data)
    },
    inputLmGooglePlacesAutocomplete (value) {
      if (!value) {
        this.value.latLong = []
        this.value.formattedAddress = ''
      }
    }
  }
}
</script>
